import type { App } from 'vue'
import router from '@/router'

// ---- 环境配置 ----
const dsn = import.meta.env.VITE_SENTRY_DSN
const isDev = import.meta.env.DEV

/**
 * beforeSend 钩子：决定事件是否上报到 Sentry
 *
 * @returns event 表示放行，null 表示丢弃
 */
const beforeSend = (event: Any, hint: Any) => {
  const exception = hint.originalException

  // 401 已由 axios 拦截器处理（reLogin），无需重复上报
  if ((exception as Any)?.response?.status === 401) return null

  return event
}

// ---- 防重复初始化 ----
let initialized = false

const appUseSentry = (app: App) => {
  if (initialized || !dsn || isDev) return

  initialized = true

  return import('@sentry/vue').then((Sentry) => {
    return Sentry.init({
      app,
      dsn,
      beforeSend,
      sendDefaultPii: true,
      ignoreErrors: [
        /imageMousePointerUpdate is not defined/,
        /Failed to fetch dynamically imported module|loading chunk|chunk load failed/i,
      ],
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^https:\/\/.*\.infshop\.net\/api/],
    })
  })
}

export default appUseSentry
